import React from 'react';
import './lastBookingForm.css';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLastBookingFormAction } from "../../redux/rootReducer";
import { LAST_BOOKING_FORM_INITIAL } from "../../redux/initialStateConstant";
import { getBookingUsersSagaAction, getWeekBookingSagaAction } from "../../redux/sagaActions";

const LastBookingForm = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const last_booking_form = useSelector(state => state.last_booking_form);
    const currentEstablishment = useSelector(state => state.currentEstablishment);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content last__booking-form">
                    <div className="form__header">
                        <div className="form__close"
                            onClick={ () => dispatch(setLastBookingFormAction(LAST_BOOKING_FORM_INITIAL)) }
                        />
                        <div className="form__title">Последние записи</div>
                    </div>
                    <div className="form__field">
                        <div className="table last__booking-table">
                            <div className="table__row table__row--header table__row--last-booking last__booking-row">
                                <div className="table__cell">Занятие</div>
                                <div className="table__cell">Дата занятия</div>
                                <div className="table__cell">Дата записи</div>
                            </div>
                            {
                                last_booking_form.last_booking.map(el => {
                                    return (
                                        <div className="table__row table__row--last-booking last__booking-row table__row--hover" key={ el.id }
                                            onClick={ async () => {
                                                // Переходим на страницу расписания
                                                await history.push('/fitness/booking');
                                                // Запрашиваем расписание для нужной неделе
                                                dispatch(getWeekBookingSagaAction({
                                                    establishment: currentEstablishment,
                                                    date: el.booking_d
                                                }));
                                                // Получение списка пользователей для указанной записи
                                                dispatch(getBookingUsersSagaAction({
                                                    booking_id: el.booking_id
                                                }));
                                                // Закрываем список последних записей
                                                dispatch(setLastBookingFormAction(LAST_BOOKING_FORM_INITIAL));
                                            } }
                                        >
                                            <div className="table__cell">{ el.type }</div>
                                            <div className="table__cell">{ el.booking_date_time }</div>
                                            <div className="table__cell">{ el.date_time }</div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LastBookingForm;